import { render, staticRenderFns } from "./MaterialCategorySelect.vue?vue&type=template&id=2b6c9fca&scoped=true"
import script from "./MaterialCategorySelect.vue?vue&type=script&lang=js"
export * from "./MaterialCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6c9fca",
  null
  
)

export default component.exports